document.addEventListener("DOMContentLoaded", function () {
    var swiper = new Swiper('.testimonials-swiper', {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 20,
          direction: 'horizontal',
          navigation: {
              nextEl: '.button-next',
              prevEl: '.button-prev',
          },
         breakpoints: {
            0: {
              slidesPerView: 3,
              spaceBetween: 20,
              direction: 'vertical',
               navigation: {
              nextEl: '.button-next',
              prevEl: '.button-prev',
            }
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
              direction: 'horizontal',
            },
            1065: {
              slidesPerView: 3,
              spaceBetween: 30,
              direction: 'horizontal',
            },
          },
      });
});
